import * as React from 'react'
export function XShared({ title, height = 25, width = 24, ...props }) {
  return (
    <div style={{ width, height }}>
      <svg xmlns="https://www.w3.org/2000/svg" fill="none" width="120%" height="120%" {...props}>
        <title>{title}</title>
        <path
          fill="#142E57"
          d="M13.969 10.333 22.707.176h-2.07l-7.588 8.82L6.99.175H0l9.164 13.336L0 24.163h2.07l8.013-9.313 6.4 9.313h6.989l-9.504-13.83h.001Zm-2.836 3.297-.929-1.328L2.817 1.735h3.18l5.962 8.527.929 1.329 7.75 11.085h-3.181l-6.324-9.046Z"
        />
      </svg>
    </div>
  )
}
export default XShared
